import {
  PackageDepartmentEnum,
  PackageRecurrenceEnum,
  PackageStatusEnum,
} from "@/__generated__/graphql";

export const getPackageBillingTypeText = (
  department: PackageDepartmentEnum,
  repeatEvery: PackageRecurrenceEnum,
) => {
  if (
    department === PackageDepartmentEnum.Aircon &&
    repeatEvery != PackageRecurrenceEnum.AdHoc
  ) {
    return "Prepaid";
  } else {
    return "Postpaid";
  }
};

export const packageStatusLabel = (status: PackageStatusEnum) => {
  switch (status) {
    case PackageStatusEnum.Active:
      return "Active";
    default:
      return "Inactive";
  }
};
